module.exports = __webpack_public_path__ + "static/media/icon-personalization.aa0781f8.png";